@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px; padding-left: 1em; padding-right: 1em; padding-top: 1em">
    <h3 style="margin: 0">Urit</h3>
    <div>
      Lemonatorissa: <a [href]="lemonatorProjektitEncodedUriObservable | async" target="_BLANK">{{ lemonatorProjektitUriObservable | async }}</a>
    </div>
    <div>
      Lemonaidissa: <a [href]="lemonaidProjektitEncodedUriObservable | async" target="_BLANK">{{ lemonaidProjektitUriObservable | async }}</a>
    </div>
  </div>
}

<div class="projekti-container">
  @if (projektitArrayObservable | async; as kaikkiProjektitGroupit) {
    <div>
      @if (kaikkiProjektitGroupit?.length) {
        <table>
          <thead class="checkbox-title-row">
            <th></th>
            <th></th>
            <th class="checkbox-title">Lemonaidissa</th>
            <th class="checkbox-title">Kirjanpidossa</th>
            <th class="checkbox-title">Raporteilla</th>
          </thead>
          @for (projektiLomake of kaikkiProjektitGroupit; track projektiLomake) {
            <tr>
              <td>
                <mat-form-field class="projektin-nimi">
                  <mat-label>Nimi</mat-label>
                  <input #nimi type="text" [formField]="projektiLomake.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                  <mat-error>
                    @if (onkoVirhe(projektiLomake.nimi, 'required')) {
                      Lisää nimi
                    }
                  </mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="projektin-vari">
                  <mat-label>Väri</mat-label>
                  <mat-select [className]="colorNameAndClassMap[projektiLomake.vari().value()]" style="font-weight: bold" [formField]="projektiLomake.vari">
                    <mat-option value="pun"><span class="red-text">Punainen</span></mat-option>
                    <mat-option value="sin"><span class="blue-text">Sininen</span></mat-option>
                    <mat-option value="vsi"><span class="light-blue-text">Vaalean sininen</span></mat-option>
                    <mat-option value="kel"><span class="yellow-text">Keltainen</span></mat-option>
                    <mat-option value="vih"><span class="green-text">Vihreä</span></mat-option>
                    <mat-option value="vio"><span class="purple-text">Violetti</span></mat-option>
                    <mat-option value="har"><span class="light-gray-text">Harmaa</span></mat-option>
                  </mat-select>
                  <mat-error>
                    @if (onkoVirhe(projektiLomake.vari, 'required')) {
                      Valitse väri
                    }
                  </mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-checkbox class="checkbox" [formField]="projektiLomake.viewableInLemonaid"></mat-checkbox>
              </td>
              <td>
                <mat-checkbox class="checkbox" [formField]="projektiLomake.usableInLemonator"></mat-checkbox>
              </td>
              <td>
                <mat-checkbox class="checkbox" [formField]="projektiLomake.viewableInLemonator"></mat-checkbox>
              </td>
            </tr>
          }
        </table>
      } @else {
        <div style="padding: 90px 40px; text-align: center; font-size: 20px; color: darkgray">Asiakkaalla ei ole vielä yhtään projektia.</div>
      }
    </div>
  } @else {
    <div style="padding: 90px 40px; text-align: center; font-size: 20px; color: darkgray">
      Ladataan asiakkaan projekteja.
      <mat-progress-bar style="margin-top: 15px" mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>

@if (showCommonError) {
  <div class="error-text common-error">Projektien tallentamisen aikana tapahtui virhe. Virhe on tallennettu. Ole hyvä ja ota yhteys ylläpitoon.</div>
}

<div class="dialog-action-container">
  <app-button (click)="createNewProject()" actionId="Lisää uusi projekti" additionalClass="add-btn" matIcon="add"> Lisää uusi projekti </app-button>
  <app-primary-button (click)="saveValidProjektit()" actionId="Tallenna projekti" [actionContext]="projektienArvot()">
    {{ 'yleiset.tallenna' | translate | async }}
  </app-primary-button>
</div>
